var exports = {
  "kL": "xfd349460--2abe73--container",
  "Hj": "xfd349460--2abe73--inner-container",
  "E5": "xfd349460--2abe73--left-side",
  "DD": "xfd349460--2abe73--title",
  "VE": "xfd349460--2abe73--link-buttons",
  "Sl": "xfd349460--2abe73--image",
};

module.exports = exports;
